import React, { useMemo, useState, useCallback } from "react";
import DragAndDrop from "../components/DragAndDrop";

interface GlobalDragAndDropContext {
  isDragging: boolean;
}

export const GlobalDragAndDropContext = React.createContext<
  GlobalDragAndDropContext
>({
  isDragging: false,
});

export const GlobalDragAndDropProvider: React.FC = props => {
  const [isDragging, setIsDragging] = useState(false);

  const onEnter = useCallback(() => {
    setIsDragging(true);
  }, []);
  const onDragOver = useCallback(isOver => {
    setIsDragging(isOver);
  }, []);
  const onDrop = useCallback((_: File[]) => {
    setIsDragging(false);
  }, []);

  const value = useMemo(() => {
    return {
      isDragging,
    };
  }, [isDragging]);
  return (
    <GlobalDragAndDropContext.Provider value={value}>
      <DragAndDrop
        onDragEnter={onEnter}
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        {props.children}
      </DragAndDrop>
    </GlobalDragAndDropContext.Provider>
  );
};
